var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZjylogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1888_5009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4947 8.95025C28.0752 8.8104 27.644 8.70551 27.2128 8.63559C26.5252 3.76423 22.3298 0 17.2603 0C12.2025 0 7.99541 3.76423 7.31948 8.64724C3.1357 9.32317 -0.057485 12.9942 0.000784831 17.3877C0.0707086 22.1775 4.05637 26 8.8578 26H9.592L15.4423 16.3738L19.4979 20.1147C20.1505 20.7091 21.1877 20.5693 21.6422 19.8117L26.6184 11.619C27.4226 11.7355 28.1801 12.0269 28.8444 12.4464C30.4409 13.4603 31.5015 15.2434 31.5015 17.2712C31.5015 20.4177 28.9492 22.97 25.8027 22.97H14.172L12.3307 26H25.6861C30.5458 26 34.5898 22.026 34.5431 17.1663C34.4849 13.3321 31.956 10.0807 28.4947 8.95025ZM20.0806 16.537L16.025 12.7961C15.3724 12.2017 14.3352 12.3416 13.8807 13.0991L7.91383 22.9234C5.15184 22.5038 3.03082 20.1264 3.03082 17.2595C3.03082 14.6374 4.80222 12.4231 7.21459 11.7589C7.6924 11.619 8.20518 11.5491 8.72961 11.5491H10.2446V10.0341C10.2446 9.50964 10.3029 9.00852 10.4078 8.51905C11.0954 5.38413 13.904 3.01838 17.2603 3.01838C20.9896 3.01838 24.0546 5.94352 24.2643 9.62618L20.0806 16.537Z",
    fill: "url(#paint0_linear_1888_5009)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1888_5009",
    x1: 0.000784831,
    y1: 12.9977,
    x2: 34.5226,
    y2: 12.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00654545,
    stopColor: "#288DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#0AB9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1888_5009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5191,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZjylogo);
export default __webpack_public_path__ + "static/media/zjylogo.5a5c844e.svg";
export { ForwardRef as ReactComponent };